import { Component } from 'react';

/**
 * Catches a render error in one page so the app shows an error card instead of
 * going blank. Key it on the route path so it resets when the user navigates.
 */
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="container py-5" data-testid="page-error">
        <div className="alert alert-danger">
          <h5 className="alert-heading">Something went wrong on this page.</h5>
          <p className="mb-3">{this.state.error.message || 'An unexpected error occurred.'}</p>
          <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
